import React, { useState } from 'react'
import { IoCalendarOutline } from 'react-icons/io5'
import { DateTime } from 'luxon'

const DateRangePicker = ({ dateRange, setDateRange }) => {
  const [showContentModal, setShowContentModal] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setShowContentModal(false)
  }

  const hasRange = dateRange?.start !== '' && dateRange?.end !== ''

  return (
    <div className="relative">
      <button
        onClick={() => setShowContentModal(true)}
        type="button"
        className="mt-3 px-3 py-2 rounded-md border bg-white dark:bg-darkbg4 dark:text-gray-300 dark:border-gray-600 text-sm flex items-center gap-2 hover:bg-gray-50 dark:hover:bg-gray-700"
      >
        <IoCalendarOutline />
        <span className="whitespace-nowrap">
          {hasRange
            ? `${DateTime.fromISO(dateRange.start).toLocaleString(DateTime.DATE_MED)} - ${DateTime.fromISO(
                dateRange.end
              ).toLocaleString(DateTime.DATE_MED)}`
            : 'Pick the Date Range'}
        </span>
      </button>

      {showContentModal && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex justify-center items-center p-4 z-50 text-black dark:text-white">
          <div className="bg-white dark:bg-gray-800 w-full max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden p-6 max-h-[90vh] overflow-y-auto">
            <h2 className="text-lg font-semibold mb-4">Pick the Start Date and End Date</h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  Start Date
                </label>
                <input
                  type="month"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  value={dateRange.start}
                  onChange={(e) =>
                    setDateRange({
                      ...dateRange,
                      start: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="mb-4">
                <label className="block mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  End Date
                </label>
                <input
                  type="month"
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white"
                  value={dateRange.end}
                  onChange={(e) =>
                    setDateRange({
                      ...dateRange,
                      end: e.target.value,
                    })
                  }
                  required
                />
              </div>

              <div className="flex justify-end mt-4">
                <button
                  type="button"
                  onClick={() => setShowContentModal(false)}
                  className="bg-gray-200 dark:bg-gray-600 dark:text-gray-200 px-4 py-2 rounded-md mr-2"
                >
                  Cancel
                </button>
                <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default DateRangePicker
